<template>
  <!-- <div class="index_content" > -->
  <div class="index_content">
    <div class="i-font" :class="[color[cKey],dataDetial.icon]"></div>
    <!-- <el-tooltip content="工作目标与规划" placement="top"> -->
      <div class="i-des" :title="dataDetial.headline">{{ dataDetial.subheading }}</div>
    <!-- </el-tooltip> -->
  </div>
</template>

<script>
export default {
  name: 'IndexItem',
  props: ['dataDetial', 'cKey'],
  data () {
    return {

      color: ['c-one', 'c-two', 'c-three', 'c-four']
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    // console.log(this.dataDetial)
  }
}
</script>

<style scoped>
.index_content {
    text-align: center;
    border: 1px solid rgb(200, 200, 200);
    width: 98px;
    height: 98px;
    padding: 10px 5px;
    line-height: 45px;
    background-color: rgb(255,255,255);
}
.index_content:hover{
   background-color: rgb(220, 220, 220);
   cursor: pointer;
}
.i-font {
  font-size: 45px;
  margin-bottom: 5px;
}
.i-des {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.c-one {
  color: #67C23A;
}
.c-two {
  color: #E6A23C;
}
.c-three {
  color: #409EFF;
}
.c-four {
  color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/IndexItem.vue